import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'navigation.login',
    defaultMessage: 'Log in',
  },
  signUp: {
    id: 'navigation.signUp',
    defaultMessage: 'Sign up',
  },
  experiences: {
    id: 'navigation.experiences',
    defaultMessage: 'Experiences',
  },
  magazine: {
    id: 'navigation.magazine',
    defaultMessage: 'Magazine',
  },
  account: {
    id: 'navigation.account',
    defaultMessage: 'Account',
  },
  itinerary: {
    id: 'navigation.itinerary',
    defaultMessage: 'Itinerary',
  },
  settings: {
    id: 'navigation.settings',
    defaultMessage: 'Settings',
  },
  signOut: {
    id: 'navigation.signOut',
    defaultMessage: 'Sign out',
  },
  back: {
    id: 'navigation.backToExperiences',
    defaultMessage: 'Back to experiences',
  },
});
